/* eslint-disable no-unused-expressions */

export default class Ticker extends CoreJS.BaseComponent {
  static CLASS_NAMESPACE = 'ticker';


  constructor(componentHost) {
    super(componentHost);
    this.animationTimeOut = 5000;
    this.animationTimers = new Map();
    this.initialize();
  }

  initialize() {
    super.initialize();
    this.manageClones();
    this.initEvents();
    this.initIntersectionObservers();
  }
  initEvents() {
    const allTickers = document.querySelectorAll('.ticker-component');

    allTickers.forEach((ticker) => {
      ticker.addEventListener('mouseenter', () => {
        this.animationPause(ticker);
      });

      ticker.addEventListener('mouseleave', () => {
        this.animationStart(ticker);
      });
    });
  }

  manageClones() {
    const linesWrappers = document.querySelectorAll('.ticker-line');

    if (!linesWrappers.length) return console.warn('Élément wrapper not find ', linesWrappers);

    linesWrappers.forEach((lineWrapper) => {
      const lineContent = lineWrapper.querySelector('.ticker-content__list');

      for (let i = 0; i < this.computeNumberOfContentToClone(lineContent, lineWrapper); i++) {
        const clonedList = this.cloneList(lineContent);
        lineWrapper.appendChild(clonedList);
      }
    });
  }

  animationStart(ticker) {
    if (this.animationTimers.has(ticker)) {
      clearTimeout(this.animationTimers.get(ticker));
    }

    ticker.dataset.animated = 'true';

    const tickerTimerId = setTimeout(() => {
      ticker.dataset.animated = 'false';
    }, this.animationTimeOut);

    this.animationTimers.set(ticker, tickerTimerId);
  }

  animationPause(ticker) {
    if (this.animationTimers.has(ticker)) {
      clearTimeout(this.animationTimers.get(ticker));
      this.animationTimers.delete(ticker);
    }

    ticker.dataset.animated = 'false';
  }

  initIntersectionObservers() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animationStart(entry.target);
        } else {
          this.animationPause(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    const allTickers = document.querySelectorAll('.ticker-component');

    allTickers.forEach((element) => {
      observer.observe(element);
    });

    return observer;
  }

  cloneList(listToClone) {
    const clonedList = listToClone.cloneNode(true);
    clonedList.classList.add('clone');
    return clonedList;
  }

  computeNumberOfContentToClone(lineContent) {
    return Math.ceil(window.innerWidth / lineContent.offsetWidth) + 1;
  }
}

// Register the Ticker component with the BaseComponent
CoreJS.BaseComponent.registerComponent(Ticker.CLASS_NAMESPACE, Ticker);

